import { useMutation } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';
import { multipartFormDataConfig } from 'app/utils/multipartFormDataConfig';

import { broadcastPropsUpdated } from '../../../../components/preview-messages';

interface UpdateWebsiteFaviconParams {
  websiteId: string;
  file: File;
}

function updateWebsiteFavicon({ websiteId, file }: UpdateWebsiteFaviconParams) {
  const formData = new FormData();
  formData.append('favicon', file);
  return axiosPrivate
    .put(
      `/v3/pharmacist/plus-websites/${websiteId}/themes/favicons`,
      formData,
      multipartFormDataConfig
    )
    .then((r) => r.data);
}

export function useUpdateWebsiteFavicon() {
  return useMutation({
    mutationFn: updateWebsiteFavicon,
    onSuccess: () => broadcastPropsUpdated(),
    meta: {
      successMessage: 'Favicon updated successfully',
      errorMessage: 'Failed to update favicon',
    },
  });
}
